import { render } from "./BaseBackground.vue?vue&type=template&id=e9781562"
import script from "./BaseBackground.vue?vue&type=script&lang=js"
export * from "./BaseBackground.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__